function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Beneficiary-Menu/My-Courses",
  transform: "translate(-79.000000, -266.000000)",
  stroke: "currentColor",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(80.000000, 267.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 6.5,
  x2: 14.5450765,
  y2: 6.5,
  id: "Line",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6,
  y1: 10.5,
  x2: 14.5450765,
  y2: 10.5,
  id: "Line-Copy-2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 14.5,
  x2: 14.5450765,
  y2: 14.5,
  id: "Line-Copy",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  strokeLinejoin: "round",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 5
}))));

var SvgBeneficiaryIcon2 = function SvgBeneficiaryIcon2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeneficiaryIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beneficiary-icon-2.8a6bf666.svg";
export { ForwardRef as ReactComponent };